import { useCallback } from 'react'
import { get } from 'lodash'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Add from '@mui/icons-material/Add'
import Delete from '@mui/icons-material/Delete'

const FormikArrayField = ({ formik, name, label, addLabel, placeholder }) => {
  const values = get(formik.values, name, [])
  const hasError = get(formik.touched, name) && Boolean(get(formik.errors, name))

  const handleAdd = useCallback(() => {
    formik.setFieldValue(name, [...values, ''])
  }, [formik, name, values])

  const handleRemove = useCallback((index) => {
    const newValues = values.filter((_, i) => i !== index)
    formik.setFieldValue(name, newValues)
  }, [formik, name, values])

  return (
    <Box>
      {label && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {label}
        </Typography>
      )}

      {values.map((value, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <TextField
            fullWidth
            size="small"
            placeholder={placeholder}
            value={value}
            onChange={(e) => formik.setFieldValue(`${name}[${index}]`, e.target.value)}
            error={hasError && Boolean(get(formik.errors, `${name}[${index}]`))}
            helperText={get(formik.errors, `${name}[${index}]`)}
          />
          <IconButton
            size="small"
            onClick={() => handleRemove(index)}
            color="default"
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ))}

      <Button
        size="small"
        startIcon={<Add />}
        onClick={handleAdd}
      >
        {addLabel}
      </Button>

      {hasError && typeof get(formik.errors, name) === 'string' && (
        <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
          {get(formik.errors, name)}
        </Typography>
      )}
    </Box>
  )
}

export default FormikArrayField
